import { getBezierPath, getMarkerEnd } from 'react-flow-renderer';

const CustomEdge = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    // eslint-disable-next-line no-unused-vars
    data,
    arrowHeadType = 'arrow',
    markerEndId,
}) => {
    const edgePath = getBezierPath(
        {
            sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition,
        },
    );
    const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
    return (
        <>
            <path id={id} style={style} className="react-flow__edge-path" d={edgePath} markerEnd={markerEnd} />
            <text>
                <textPath href={`#${id}`} style={{ fontSize: '12px' }} startOffset="50%" textAnchor="bottom" />
            </text>
        </>
    );
};

export default CustomEdge;
